import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function Audit() {
  const { data: rows } = useQuery({ queryKey: ["cms-audit"], queryFn: async () => (await api.get("/cms/audit")).data });
  return (
    <div>
      <h1 className="text-3xl font-bold uppercase tracking-tight text-ink mb-1">Audit Log</h1>
      <p className="text-subtle text-sm mb-6">Publish/unpublish, SEO, redirect, lead status & branch changes</p>
      <div className="card-surface !hover:translate-y-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="text-left text-faint border-b border-white/10">
              <th className="px-4 py-3 font-medium">When</th>
              <th className="px-4 py-3 font-medium">User</th>
              <th className="px-4 py-3 font-medium">Action</th>
              <th className="px-4 py-3 font-medium">Target</th>
              <th className="px-4 py-3 font-medium">Detail</th>
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((r, i) => (
              <tr key={i} className="border-b border-white/5">
                <td className="px-4 py-2.5 text-faint text-xs whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
                <td className="px-4 py-2.5 text-subtle text-xs">{r.user_email}</td>
                <td className="px-4 py-2.5 text-copper text-xs font-mono">{r.action}</td>
                <td className="px-4 py-2.5 text-ink text-xs font-mono">{r.target}</td>
                <td className="px-4 py-2.5 text-subtle text-xs">{r.detail}</td>
              </tr>
            ))}
            {(rows || []).length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-faint text-sm">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
